const e = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_starAddress",
        type: "address"
      },
      {
        internalType: "address",
        name: "_godiverseAddress",
        type: "address"
      },
      {
        internalType: "address",
        name: "_tokenAddress",
        type: "address"
      },
      {
        internalType: "uint256[]",
        name: "_prices",
        type: "uint256[]"
      },
      {
        internalType: "uint256[]",
        name: "_mintCountPerType",
        type: "uint256[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "_admin",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "bool",
        name: "_enabled",
        type: "bool"
      }
    ],
    name: "AdminAccessSet",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "_user",
        type: "address"
      }
    ],
    name: "Blacklisted",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "bool",
        name: "isEnabled",
        type: "bool"
      }
    ],
    name: "PresaleEnable",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "reserver",
        type: "address"
      }
    ],
    name: "Reserved",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "genId",
        type: "uint256"
      }
    ],
    name: "STGenMappingUpdated",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "enum StellaTabullasPresaleFactory.STType",
        name: "stType",
        type: "uint8"
      },
      {
        indexed: !1,
        internalType: "uint256[]",
        name: "tokenIdArray",
        type: "uint256[]"
      },
      {
        indexed: !1,
        internalType: "uint256[]",
        name: "genIdArray",
        type: "uint256[]"
      },
      {
        indexed: !1,
        internalType: "uint256[]",
        name: "godiverseArray",
        type: "uint256[]"
      }
    ],
    name: "STTokenIdNGenIdArrayUpdated",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint256[]",
        name: "_saleSchedule",
        type: "uint256[]"
      }
    ],
    name: "SaleScheduleUpdated",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "buyer",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "price",
        type: "uint256"
      }
    ],
    name: "SoldChest",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "enum StellaTabullasPresaleFactory.STType",
        name: "stType",
        type: "uint8"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "counter",
        type: "uint256"
      }
    ],
    name: "TypeCounterUpdated",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint256[]",
        name: "typeCounter",
        type: "uint256[]"
      }
    ],
    name: "TypeMaxUpdated",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "_user",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "enum MultiWhitelist.WhitelistType",
        name: "whitelistType",
        type: "uint8"
      }
    ],
    name: "Whitelisted",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address"
      }
    ],
    name: "blacklist",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "users",
        type: "address[]"
      }
    ],
    name: "blacklistBatch",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "enum StellaTabullasPresaleFactory.STType",
        name: "_stType",
        type: "uint8"
      }
    ],
    name: "getAvailableCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getCurrentForSaleType",
    outputs: [
      {
        internalType: "enum MultiWhitelist.ForSaleType",
        name: "",
        type: "uint8"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "enum StellaTabullasPresaleFactory.STType",
        name: "_stType",
        type: "uint8"
      }
    ],
    name: "getStTokenIdArray",
    outputs: [
      {
        internalType: "uint256[]",
        name: "tokenIdArray",
        type: "uint256[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "godiverseContract",
    outputs: [
      {
        internalType: "contract IApeironGodiverseCollection",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "admin",
        type: "address"
      }
    ],
    name: "isAdmin",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "isEnabled",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address"
      }
    ],
    name: "isReachedPurchaseLimit",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address"
      }
    ],
    name: "isWhitelisted",
    outputs: [
      {
        components: [
          {
            internalType: "bool",
            name: "isWhitelisted",
            type: "bool"
          },
          {
            internalType: "enum MultiWhitelist.WhitelistType",
            name: "whitelistType",
            type: "uint8"
          }
        ],
        internalType: "struct MultiWhitelist.Whitelist",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]"
      },
      {
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "onERC1155BatchReceived",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "onERC1155Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "enum StellaTabullasPresaleFactory.STType",
        name: "",
        type: "uint8"
      }
    ],
    name: "prices",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "enum StellaTabullasPresaleFactory.STType",
        name: "_stType",
        type: "uint8"
      }
    ],
    name: "purchase",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "enum MultiWhitelist.WhitelistType",
        name: "",
        type: "uint8"
      }
    ],
    name: "purchaseLimits",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_reservedAddress",
        type: "address"
      },
      {
        internalType: "uint256[]",
        name: "_reserveCountPerType",
        type: "uint256[]"
      }
    ],
    name: "reserve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "admin",
        type: "address"
      },
      {
        internalType: "bool",
        name: "enabled",
        type: "bool"
      }
    ],
    name: "setAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "_isEnabled",
        type: "bool"
      }
    ],
    name: "setEnabled",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "_forSaleSchedule",
        type: "uint256[]"
      }
    ],
    name: "setForSaleSchedule",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "_purchaseLimits",
        type: "uint256[]"
      }
    ],
    name: "setPurchaseLimits",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "enum StellaTabullasPresaleFactory.STType",
        name: "_stType",
        type: "uint8"
      },
      {
        internalType: "uint256[]",
        name: "_tokenIdArray",
        type: "uint256[]"
      },
      {
        internalType: "uint256[]",
        name: "_starGenArray",
        type: "uint256[]"
      },
      {
        internalType: "uint256[]",
        name: "_godiverseGenArray",
        type: "uint256[]"
      },
      {
        internalType: "bool",
        name: "_isReset",
        type: "bool"
      }
    ],
    name: "setStTokenIdNGenIdArray",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "enum StellaTabullasPresaleFactory.STType",
        name: "_stType",
        type: "uint8"
      },
      {
        internalType: "uint256",
        name: "_newCount",
        type: "uint256"
      }
    ],
    name: "setTypeCounter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "_typeMax",
        type: "uint256[]"
      }
    ],
    name: "setTypeMax",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "starContract",
    outputs: [
      {
        internalType: "contract IApeironStar",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4"
      }
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "token",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "enum StellaTabullasPresaleFactory.STType",
        name: "",
        type: "uint8"
      }
    ],
    name: "typeCounter",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "enum StellaTabullasPresaleFactory.STType",
        name: "",
        type: "uint8"
      }
    ],
    name: "typeMax",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "userPurchaseCounter",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address"
      },
      {
        internalType: "enum MultiWhitelist.WhitelistType",
        name: "whitelistType",
        type: "uint8"
      }
    ],
    name: "whitelist",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "users",
        type: "address[]"
      },
      {
        internalType: "enum MultiWhitelist.WhitelistType[]",
        name: "whitelistTypes",
        type: "uint8[]"
      }
    ],
    name: "whitelistBatch",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_tokenAddress",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_wallet",
        type: "address"
      }
    ],
    name: "withdrawFunds",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];
export {
  e as default
};
//# sourceMappingURL=polygon-star-presale.json.js.map
